export function success(res,that){
	that.$message({
	  message: res.msg,
	  type: 'success',
	  customClass:'zZindex'
	});
}

export function error(res,that){
	that.$message.error({
	  message: res.msg,
	  customClass:'zZindex'
	});
}
export function error_text(text,that){
	that.$message.error({
	  message: text,
	  customClass:'zZindex'
	});
}